import css from 'styled-jsx/css';

const style = css`
  :global(.ant-select-selection) {
    border-color: #d9d9d9;
  }
`;

export default style;
